/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon24Regular = forwardRef('DataChartTrendXyUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.75 3.75a.75.75 0 0 0-1.5 0V18A3.75 3.75 0 0 0 6 21.75h15.25a.75.75 0 0 0 0-1.5H6A2.25 2.25 0 0 1 3.75 18V3.75Z" }),
        React.createElement("path", { d: "M21.405 7.78a.75.75 0 0 0-1.06-1.06L14.5 12.564l-2.679-2.678a1.25 1.25 0 0 0-1.767 0L6.47 13.47a.75.75 0 1 0 1.06 1.06l3.407-3.407 2.68 2.679a1.25 1.25 0 0 0 1.767 0l6.021-6.022Z" })));
});
